import assignPlace from './assignPlace';

export default function assignAirport(basicEntity: any, airportBlob: any) {
    if (basicEntity && airportBlob) {
        basicEntity = {
            ...basicEntity,
            ...{
                iataCode: airportBlob.iataCode,
            },
        };

        basicEntity = assignPlace(basicEntity, airportBlob);
        return basicEntity;
    }
    return null;
}
